export default __webpack_public_path__ + "static/media/suit-6.faa9c6d9.jpg";